import type { WCardSummaryView } from '@zola/svc-web-api-ts-client';

export const getCardDefaultColor = (card?: WCardSummaryView): string => {
  if (!card?.colors) return '';

  const [defaultColor] = card.colors;
  return defaultColor.value || '';
};

export const getCardThumbnailByColor = (card: WCardSummaryView, color: string): string => {
  if (!card.colors) return '';

  const defaultColor = getCardDefaultColor(card);
  if (!defaultColor) return '';

  const matchColorCard = card.colors.find(cardColor => cardColor.value === color);
  if (matchColorCard) return matchColorCard.plp_front_image_url || '';

  const defaultColorCard = card.colors.find(cardColor => cardColor.value === defaultColor);
  return defaultColorCard?.plp_front_image_url || '';
};
